import Modal from "@mui/material/Modal";
import { Box, CircularProgress } from "@mui/material";
import React from "react";

export const ActivityModal = () => {
  return (
    <Modal
      open={true}
      aria-labelledby="modal-modal-title"
      color="white"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          width: 50,
          height: 50,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    </Modal>
  );
};
